import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getTreatment } from 'Services/Features/Treatment/Utils/treatmentUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindTreatment from './Filter/FindTreatment';
import TreatmentTable from './TreatmentTable';

const TreatmentContain = () => {
    const dispatch = useDispatch();
    const treatments = useSelector((state) => state.treatment.treatments);
    const loading = useSelector((state) => state.treatment.loading);
    const error = useSelector((state) => state.treatment.error);
    const [refetch, setRefetch] = useState(false);
    const filters = useSelector(state => state.treatment.filters);

    useEffect(() => {
        dispatch(getTreatment(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindTreatment />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && treatments.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Perawatan Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <TreatmentTable setRefetch={setRefetch} />
                    )}
                </Row>
                </Col>
        </Fragment>
    );
};

export default TreatmentContain;